<template>
  <div>
    <div class="app-container">
      <van-row style="position: absolute;top: 1%;right: 1%;text-align: center;border: 1px solid #aaaaaa;font-size: 16px;width: 5.25rem;color: #565656;border-radius: 3px;padding-bottom: 8px;">
        <van-col :span="24">
          <h5 style="font-family: Kaiti;color: #aaaaaa;">缅怀人次</h5>
          <shuzigundong :number="sumCount" :font-size="14" />
        </van-col>
      </van-row>
      <transition
        class="animated"
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOutUp"
      >
        <h2 v-show="showXianhuaAnimate" style="position: absolute;top: 22%;right: 15%;color: #f0815b;">+1</h2>
      </transition>
      <transition
        class="animated"
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOutUp"
      >
        <h2 v-show="showLazhuAnimate" style="position: absolute;top: 22%;right: 3%;color: #f0815b;">+1</h2>
      </transition>
      <van-row style="padding-top: 48%;width: 100%;text-align: center;">
        <van-col :span="6" :offset="9" class="xianhua" style="min-height: 2rem;">
          <img v-show="showXianhua&&!showXianhuaAnimate" src="../../image/smhx_ysmh/3xh.png" style="width: 18vmin;" >
          <transition
            class="animated"
            enter-active-class="animated zoomIn"
            leave-active-class="animated zoomOut"
            @after-enter="showXianhuaAnimate=false"
            @after-leave="showXianhua=true"
          >
            <img v-show="showXianhuaAnimate" src="../../image/smhx_ysmh/3xh.png" style="width: 50vmin;position: absolute;bottom: 25%;left: 23%;" >
          </transition>
        </van-col>
        <van-col :span="8" :offset="8" class="lazhu" style="min-height: 1.6rem;">
          <img v-show="showLazhu&&!showLazhuAnimate" src="../../image/smhx_ysmh/3lz.png" style="width: 21vmin;" >
          <transition
            class="animated"
            enter-active-class="animated zoomIn"
            leave-active-class="animated zoomOut"
            @after-enter="showLazhuAnimate=false"
            @after-leave="showLazhu=true"
          >
            <img v-show="showLazhuAnimate" src="../../image/smhx_ysmh/3lz.png" style="width: 50vmin;position: absolute;bottom: 15%;left: 23%;" >
          </transition>
        </van-col>
      </van-row>
    </div>
    <van-row :gutter="20" type="flex" justify="center">
      <van-col :span="8" style="text-align: center;" @click.native="handleShowXH">
        <img src="../../image/smhx_ysmh/xianh.png" style="width: 100%;" >
      </van-col>
      <van-col :span="8" style="text-align: center;" @click.native="handleShowLZ">
        <img src="../../image/smhx_ysmh/laz.png" style="width: 100%;" >
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Vue from 'vue'
import animate from 'animate.css'
Vue.use(animate)
import { Col, Row } from 'vant'
import shuzigundong from './number.vue'
import { getCount, addCount } from '../../api/count.js'
export default {
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    shuzigundong
  },
  data() {
    return {
      showXianhua: false,
      showXianhuaAnimate: false,
      showLazhu: false,
      showLazhuAnimate: false,
      showCount: false,
      count: 0,
      sumCount: '00000'
    }
  },
  mounted() {
    this.getCount()
  },
  methods: {
    getCount() {
      getCount().then(response => {
        this.count = parseInt(response.data.count)
        this.sumCount = (Array(5).join(0) + this.count).slice(-5)
      })
    },
    handleShowXH() {
      if (!this.showXianhua) {
        this.showXianhuaAnimate = true
        this.showXianhua = false
        this.showCount = true
        this.PrefixInteger()
        addCount(returnCitySN.cip)
      }
    },
    handleShowLZ() {
      if (!this.showLazhu) {
        this.showLazhuAnimate = true
        this.showLazhu = false
        this.showCount = true
        this.PrefixInteger()
        addCount(returnCitySN.cip)
      }
    },
    PrefixInteger() {
      this.count++
      this.sumCount = (Array(5).join(0) + this.count).slice(-5)
    }
  }
}
</script>

<style scoped>
  .app-container {
    width: 100%;
    background-image: url(../../image/smhx_ysmh/mub.png);
    background-size: 100% 100%;
    height: 75vmin;
    position: relative;
  }
</style>
